// extracted by mini-css-extract-plugin
module.exports = {"bundles":"JPBundle_bundles__9ffEN"};